<template>
  <div class="tour-list__sidebar">
    <div class="c-sidebar w-100">
      <div class="sidebar" :class="getOpenFilterMobile ? 'open-filter' : ''">
        <div class="sidebar__name hide-in-not-desktop">
          <span> {{ getTourCategoryTitle }}</span>
        </div>
        <div class="sidebar__header">
          
          <span class="fa-num hide-in-not-desktop"> {{ getResultCount }} تور پیدا شد</span>

          <span class="hide-in-desktop"> فیلتر کردن </span>

          <button class="hide-in-desktop btn" @click="toggleFilterBoxMobile">
            <i class="icon-close" />
          </button>

          <button class="hide-in-not-desktop" v-if="params.length !== 0" @click="cancelFilters()">
            حذف فیلترها
          </button>
        </div>

        <FilterPart :filter="hasChildFilter" />

        <div v-for="filter in filters" :key="filter.id">
          <FilterPart
            :filter="filter"
            v-if="filter.title.toLowerCase() !== 'haschild'"
          />
        </div>
        <div class="sidebar__footer hide-in-desktop">
        <button class="btn btn--primary w-100" @click="toggleFilterBoxMobile">
          اعمال فیلتر
        </button>
      </div>
      </div>

      
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import FilterPart from "./FilterPart.vue";

export default {
  name: "SideBar",

  components: {
    FilterPart,
  },

  data() {
    return {
      hasChildFilter: {
        showType: "list",
        type: "Integer",
        slug: "has-child",
        children: [
          {
            showType: "list",
            type: "Integer",
            id: "www",
            title: "فقط تورهای موجود",
            isSelected: false,
            slug: "has-child",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(["filters", "params"]),
    ...mapGetters([
      "getOpenFilterMobile",
      "getResultCount",
      "getTourCategoryTitle",
    ]),
  },

  methods: {
    ...mapActions(["toggleFilterBoxMobile", "clearFilters"]),

    cancelFilters() {
      this.hasChildFilter.children[0].isSelected = false;
      this.clearFilters();
    },
  },
};
</script>

<style lang="scss">
@import "../style/modules/_sidebar.scss";
</style>
